import * as Atom from 'effect/unstable/reactivity/Atom';
import type * as Hydration from 'effect/unstable/reactivity/Hydration';

/**
 * The part of a serializable atom that dehydration reads: its key and its encoder.
 *
 * Typed on the value, so the value passed to `dehydrateValue` must be the value the
 * atom's own schema encodes.
 */
type SerializableValue<A> = {
  readonly [Atom.SerializableTypeId]: {
    readonly key: string;
    readonly encode: (value: A) => unknown;
  };
};

/** Encodes one value with the serializable metadata attached to its atom. */
export const dehydrateValue = <A>(
  atom: SerializableValue<A>,
  value: A
): Hydration.DehydratedAtomValue => ({
  '~effect/reactivity/Hydration/DehydratedAtom': true,
  key: atom[Atom.SerializableTypeId].key,
  value: atom[Atom.SerializableTypeId].encode(value),
  dehydratedAt: Date.now(),
});
